/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from "react";
//Redux
import { useSelector, useDispatch } from "react-redux";

import {
  Button,
  UncontrolledTooltip,
  Collapse,
  Card,
  CardBody,
  Spinner,
  Badge,
} from "reactstrap";

import { useDropzone } from "react-dropzone";

import mime from "mime";

import TextareaAutosize from "react-textarea-autosize";

import SendButton from "./SendButton.js";
import AudioButton from "./AudioButton.js";

import EmojiPicker from "emoji-picker-react";

import "./emojiPicker.scss";

// Custom methods
import {
  isFunction,
  isString,
} from "../../../../../Libs/CustomMethods/customMethods";

// actions
import {
  joinConversation,
  resetStatus,
  saveMessage,
} from "../../../../../store/operator/actions";

//i18n
import { withTranslation } from "react-i18next";

//Icons
import Icon from "./Icons";
import AudioRecord from "./AudioRecord.js";
import AnimateWidth from "../../../../Common/AnimateWidth";
import FlashMsgList from "./FlashMsgList.js";
import { showToast } from "../../../functions/utils.js";

const RichInputs = ({
  chatId,
  observer,
  joinedConversation,
  onSubmit,
  t,
  handleFile,
  quickMsg,
  supportedFiles,
}) => {
  const dispatch = useDispatch();

  const { messageOperator } = useSelector((state) => state.Operator);

  const { mainTheme } = useSelector((state) => state.Layout);

  const [isValidSubmit, setIsValidSubmit] = useState(false);

  // MESSAGE CONSTANTS
  const [messageValue, setMessageValue] = useState("");
  const [isValidMessage, setIsValidMessage] = useState(false);
  const [messageMaxLength, setMessageMaxLength] = useState(0);

  const [emojiPicker, setEmokiPicker] = useState(false);

  //FILE CONSTANTS
  const [fileObj, setFileObj] = useState(null);
  const [isValidFile, setIsValidFile] = useState(false);
  const [fileMsgError, setFileMsgError] = useState(null);
  const [newFieldsFile, setNewFieldsFile] = useState(null);
  const [isOpenFile, setIsOpenFile] = useState(false);
  const [loadingFile, setLoadingFile] = useState(false);

  //FLASH CONSTANTS
  const [searchTextFlash, setSearchTextFlash] = useState(null);
  const [defaultFlashMsg, setDefaultFlashMsg] = useState(null);
  const [flashMsg, setFlashMsg] = useState(null);
  const [refIndex, setRefIndex] = useState(null);

  //AUDIO CONSTANTS
  const [isAudioFeature, setIsAudioFeature] = useState(false);
  const [isRecordingAudio, setIsRecordingAudio] = useState(false);
  const [isOpenRecord, setIsOpenRecord] = useState(false);
  const [isOpenButton, setIsOpenButton] = useState(true);

  // REFS
  const fileInputRef = useRef(null);
  const msgRef = useRef(null);
  const prevMessages = useRef({});

  //LOCAL STORAGE
  const msgHotkey = localStorage.getItem("hotkeyToggle");
  const placeholder =
    msgHotkey === "Enter" ? t("sendWithEnter") : t("sendWithCtrlEnter");

  // TODO: insert this code in dedicated component
  const joinChatComponent = () => {
    return (
      <div className="p-3 joinChat">
        <Button color="light" className="w-100 py-3" onClick={joinChat}>
          {messageOperator?.status?.join_conversation?.loading ? (
            <Spinner animation="border" size="sm" className="spinner m-0" />
          ) : (
            t("Join conversation")
          )}
        </Button>
      </div>
    );
  };

  const joinChat = () => {
    dispatch(joinConversation(chatId));
  };

  const createFile = async (url) => {
    setLoadingFile(true);
    const response = await fetch(url);
    setLoadingFile(false);
    const data = await response.blob();
    const matchUrl = url.match(new RegExp("name." + "(.*)" + "sv"));
    const name = matchUrl[1].replace("?", "");
    const metadata = {
      type: data.type,
    };
    const file = new File([data], name, metadata);

    handleSendFile(file);
  };

  const fileToBase64 = async (file) => {
    const result_base64 = await new Promise((resolve) => {
      const fileReader = new FileReader();
      fileReader.onload = () => resolve(fileReader.result);
      fileReader.readAsDataURL(file);
    });
    return result_base64;
  };

  const handleSendFile = async (file) => {
    if (file) {
      setIsOpenFile(true);
      const fileBase64 = await fileToBase64(file);
      const dataSplit = fileBase64.split(",");

      const fileName = file?.name;
      const fileMimeType = file?.type;
      const fileType =
        fileMimeType.split("/")[0] === "application"
          ? "file"
          : fileMimeType.split("/")[0];
      const fileExts = mime?.getExtension(fileMimeType);
      const fileSize = file?.size;

      setFileObj({
        name: fileName,
        mimeType: fileMimeType,
        base64: dataSplit[1],
        formData: file,
        type: fileType,
        exts: fileExts,
        size: fileSize,
      });
    }
  };

  const handleSubmit = () => {
    if (isValidSubmit) {
      onSubmit(messageValue);
      resetAfterSent();
    }
  };

  const handleEnter = (e) => {
    if (msgHotkey === "Enter") {
      if (searchTextFlash && defaultFlashMsg) {
        setSearchTextFlash(null);
        setMessageValue(defaultFlashMsg);
        e.preventDefault();
      } else if (!e.shiftKey) {
        e.preventDefault();
        handleSubmit();
      }
    } else {
      if (searchTextFlash && defaultFlashMsg) {
        setSearchTextFlash(null);
        setMessageValue(defaultFlashMsg);
        e.preventDefault();
      } else {
        e.ctrlKey && handleSubmit();
      }
    }
  };

  const handleArrowUp = () => {
    searchTextFlash && setRefIndex(0);
  };

  const handleArrowDown = () => {
    searchTextFlash && setRefIndex(1);
  };

  const handleEscape = () => {
    if (searchTextFlash) {
      setSearchTextFlash(null);
      setMessageValue("");
    }
  };

  const resetFile = () => {
    if (fileInputRef?.current) fileInputRef.current.value = "";
    setFileObj(null);
    setNewFieldsFile(null);
    setIsValidFile(false);
    setIsOpenFile(false);
  };

  const resetAfterSent = () => {
    setMessageValue("");
    fileObj && resetFile();
  };

  const onSubmitAudio = (e) => {
    const objValidate = audioValidate(e?.file?.size);
    const isValidate = !objValidate?.error;
    if (isValidate) {
      handleFile({
        file: {
          formData: e.file,
          mimeType: e.file?.type,
          fileName: "audio.ogg",
        },
      });
      onSubmit();
      resetAfterSent();
    } else {
      showToast("error", objValidate?.message);
    }
  };

  const findFlashMessage = (value) => {
    if (value[0] === "/" && value[1] === "/") {
      setSearchTextFlash(value);
    } else {
      setSearchTextFlash(null);
    }
  };

  const toggleEmojiPicker = () => {
    setEmokiPicker(!emojiPicker);
  };

  const onEmojiClick = (event, emojiObject) => {
    setMessageValue(messageValue + emojiObject.emoji);
  };

  /***** AUDIO VALIDATE ****/
  const audioValidate = (size) => {
    const maxSizeToBytes =
      supportedFiles?.audio?.metric === "KB"
        ? supportedFiles?.audio?.maxSize * 1024
        : supportedFiles?.audio?.metric === "MB"
        ? supportedFiles?.audio?.maxSize * 1024 * 1024
        : supportedFiles?.audio?.metric === "GB"
        ? supportedFiles?.audio?.maxSize * 1024 * 1024 * 1024
        : supportedFiles?.audio?.metric === "TB"
        ? supportedFiles?.audio?.maxSize * 1024 * 1024 * 1024 * 1024
        : supportedFiles?.audio?.maxSize;
    //Validate FileSize
    if (size < maxSizeToBytes) {
      return { error: false, message: null };
    } else {
      return {
        error: true,
        message: `${t("Audio must be smaller than")} ${
          supportedFiles?.audio?.maxSize
        } ${supportedFiles?.audio?.metric}`,
      };
    }
  };

  /*****FILE VALIDATE*****/
  const fileValidate = (file) => {
    const type = file?.type;
    const extension = file?.exts;
    const size = file?.size;

    try {
      //Validate FileType
      if (
        type === "image" ||
        type === "file" ||
        type === "audio" ||
        type === "video"
      ) {
        //Validate FileExt
        if (supportedFiles[type]?.ext?.includes(extension)) {
          const maxSizeToBytes =
            supportedFiles[type]?.metric === "KB"
              ? supportedFiles[type]?.maxSize * 1024
              : supportedFiles[type]?.metric === "MB"
              ? supportedFiles[type]?.maxSize * 1024 * 1024
              : supportedFiles[type]?.metric === "GB"
              ? supportedFiles[type]?.maxSize * 1024 * 1024 * 1024
              : supportedFiles[type]?.metric === "TB"
              ? supportedFiles[type]?.maxSize * 1024 * 1024 * 1024 * 1024
              : supportedFiles[type]?.maxSize;
          //Validate FileSize
          if (size < maxSizeToBytes) {
            return { error: false, message: null };
          } else {
            return {
              error: true,
              message: `${t("Add files smaller than")} ${
                supportedFiles[type]?.maxSize
              } ${supportedFiles[type]?.metric}`,
            };
          }
        } else {
          const msgExt = ` ${t("Only")} ${t(type)} ${t(
            "with extension"
          )}: ${supportedFiles[type]?.ext?.join(", ")}`;
          return {
            error: true,
            message: `
            ${t("File extension not valid")}.
            ${supportedFiles[type]?.ext ? msgExt : ""}`,
          };
        }
      } else {
        return {
          error: true,
          message: t("File not valid"),
        };
      }
    } catch (error) {
      return {
        error: true,
        message: error,
      };
    }
  };
  useEffect(() => {
    const objValidate = fileValidate(fileObj);
    const isValidate = !objValidate?.error;
    if (isValidate) {
      setNewFieldsFile({
        file: {
          data: fileObj?.base64,
          formData: fileObj?.formData,
          mimeType: fileObj?.mimeType,
          fileName: fileObj?.name,
        },
      });
    } else {
      setNewFieldsFile(null);
    }
    setFileMsgError(objValidate?.message);
    setIsValidFile(isValidate);
  }, [chatId, fileObj]);

  /*****MESSAGE VALIDATE*****/
  const messageValidate = (message) => {
    if (message?.length <= messageMaxLength && (message !== "" || fileObj)) {
      return true;
    } else {
      return false;
    }
  };
  useEffect(() => {
    const isValidate = messageValidate(messageValue);
    setIsValidMessage(isValidate);
  }, [chatId, fileObj, messageValue, messageMaxLength]);

  /*****INPUT VALIDATE*****/
  const inputValidate = () => {
    if (
      (!fileObj && isValidMessage) ||
      (fileObj && isValidFile && isValidMessage)
    ) {
      return true;
    } else {
      return false;
    }
  };
  useEffect(() => {
    const isValidate = inputValidate();
    setIsValidSubmit(isValidate);
  }, [isValidMessage, isValidFile, fileObj]);

  const handleMessage = (value) => {
    let prev = prevMessages?.current;
    if (chatId && value !== prev[chatId]) {
      prev[chatId] = value;
    }
  };
  useEffect(() => {
    let message = messageOperator?.chats_scroll_text?.[chatId]?.textInput ?? "";
    setMessageValue(message);

    return () => {
      let prev = prevMessages?.current;
      if (chatId && isString(prev[chatId])) {
        message !== prev[chatId] && dispatch(saveMessage(chatId, prev[chatId]));
      }
    };
  }, [chatId]);

  useEffect(() => {
    handleMessage(messageValue);
    if (messageValue.length > messageMaxLength) {
      showToast("error", t("This message is too long for this channel"));
    }
  }, [messageValue]);

  useEffect(() => {
    if (quickMsg?.message) {
      setMessageValue(messageValue + " " + quickMsg.message);
    }
    if (quickMsg?.file) {
      createFile(quickMsg?.file);
    }
  }, [quickMsg]);

  useEffect(() => {
    if (flashMsg) {
      setMessageValue(flashMsg);
      setFlashMsg(null);
    }
  }, [flashMsg]);

  useEffect(() => {
    if (!searchTextFlash) {
      msgRef?.current?.focus();
      setRefIndex(null);
    }
  }, [searchTextFlash]);

  useEffect(() => {
    if (newFieldsFile) {
      handleFile(newFieldsFile);
    } else {
      handleFile({
        file: null,
      });
    }
  }, [newFieldsFile]);

  useEffect(() => {
    setMessageMaxLength(supportedFiles?.message?.maxSize ?? 0);
    setIsAudioFeature(supportedFiles?.audio ? true : false);
    resetFile();
  }, [supportedFiles]);

  useEffect(() => {
    let join_conversation = messageOperator?.status?.join_conversation;
    if (join_conversation?.success) {
      isFunction(joinedConversation) && joinedConversation(true);
      dispatch(resetStatus("join_conversation"));
    } else if (join_conversation?.error?.status) {
      showToast("error", join_conversation?.error?.message);
      dispatch(resetStatus("join_conversation"));
    }
  }, [messageOperator?.status?.join_conversation]);

  const [isDrop, setIsDrop] = useState(false);
  let counter = 0;
  useEffect(() => {
    let chatdroparea = document.getElementById("dc");
    chatdroparea.addEventListener("dragenter", (e) => {
      e.preventDefault();
      counter++;
      setIsDrop(true);
    });
    chatdroparea.addEventListener("dragleave", (e) => {
      counter--;
      if (counter === 0) {
        setIsDrop(false);
      }
    });
    chatdroparea.addEventListener("drop", (e) => {
      setTimeout(() => {
        counter = 0;
        setIsDrop(false);
      }, 300);
    });
    chatdroparea.addEventListener("dragover", (e) => {
      if (counter === 0) {
        setIsDrop(false);
      }
    });
    return () => {
      chatdroparea.removeEventListener("dragenter", (e) => {
        setIsDrop(true);
      });
      chatdroparea.removeEventListener("dragleave", (e) => {
        setIsDrop(false);
      });
      chatdroparea.removeEventListener("drop", (e) => {
        setIsDrop(false);
      });
      chatdroparea.removeEventListener("dragover", (e) => {
        setIsDrop(false);
      });
    };
  }, []);

  const onDrop = async (acceptedFiles) => {
    await handleSendFile(acceptedFiles[0]);
    setIsDrop(false);
  };

  const { getRootProps } = useDropzone({
    maxFiles: 1,
    onDrop,
  });

  return !observer?.joined ? (
    joinChatComponent()
  ) : (
    <div>
      {/*****HEADER (WIDGETS ICONS)*****/}
      {isDrop && (
        <div className="d-flex h-100 mt-3 mx-3 dropzone" {...getRootProps()}>
          <p className="m-auto">{t("DRAG 'N' DROP YOUR FILE HERE")}</p>
        </div>
      )}
      <div className="list-inline py-1 px-3">
        <Collapse isOpen={searchTextFlash && !isRecordingAudio}>
          <Card className="my-1 pt-2">
            <CardBody className="overlflow-auto p-0 ">
              <FlashMsgList
                searchTextFlash={searchTextFlash}
                setSearchTextFlash={setSearchTextFlash}
                setDefaultFlashMsg={setDefaultFlashMsg}
                setFlashMsg={setFlashMsg}
                refIndex={refIndex}
                setRefIndex={setRefIndex}
              />
            </CardBody>
            <hr className="dropdown-divider mb-0" />
          </Card>
        </Collapse>
        <Collapse isOpen={isOpenFile && !isRecordingAudio}>
          {fileMsgError && (
            <div className="d-flex mt-1">
              <Badge color="danger" className="font-size-13 wrap-normal">
                {fileMsgError}
              </Badge>
            </div>
          )}
          {!loadingFile ? (
            <Card className="my-1 pt-2">
              <CardBody className="overlflow-auto p-0 ">
                <div className="d-flex justify-content-between">
                  <div className="d-flex align-self-center w-100 overflow-auto">
                    <div>
                      <i
                        className={`bx ${
                          fileObj?.type === "file"
                            ? "bx-file-blank"
                            : fileObj?.type === "image"
                            ? "bx-image"
                            : fileObj?.type === "video"
                            ? "bx-movie"
                            : fileObj?.type === "audio"
                            ? "bx-music"
                            : "bx-file-blank"
                        } px-2  `}
                      />
                    </div>
                    <div className="overflow-auto">{fileObj?.name}</div>
                  </div>
                  <div className="align-self-center">
                    <i
                      onClick={() => {
                        resetFile();
                      }}
                      className="mdi mdi-window-close text-danger font-size-18 px-2 pointer"
                      id="deletetooltip"
                    >
                      <UncontrolledTooltip
                        placement="left"
                        target="deletetooltip"
                      >
                        {t("Delete")}
                      </UncontrolledTooltip>
                    </i>
                  </div>
                </div>
              </CardBody>
              <hr className="dropdown-divider mb-0" />
            </Card>
          ) : (
            <Card className="my-1 pt-2">
              <CardBody className="overlflow-auto p-0">
                <Spinner animation="border" size="sm" />
              </CardBody>
              <hr className="dropdown-divider mb-0" />
            </Card>
          )}
        </Collapse>

        <div className={`emoji-area ${mainTheme}`}>
          <EmojiPicker
            onEmojiClick={onEmojiClick}
            disableSearchBar
            pickerStyle={{
              boxShadow: "none",
              display: emojiPicker ? "flex" : "none",
            }}
            native
            id="emoji-picker"
            groupNames={{
              smileys_people: t("Expressions"),
              animals_nature: t("Animals & nature"),
              food_drink: t("Food & drink"),
              travel_places: t("Travel places"),
              activities: t("Activities"),
              objects: t("Objects"),
              symbols: t("Symbols"),
              flags: t("Flags"),
              recently_used: t("Recently used"),
            }}
          />
        </div>

        <li
          className="list-inline-item"
          id="emojipicker"
          onClick={toggleEmojiPicker}
        >
          <label className="m-0">
            <i
              className="mdi mdi-emoticon-happy-outline font-size-18 align-middle"
              style={{
                color: "gray",
                cursor: "pointer",
              }}
            />
          </label>
          {!emojiPicker && (
            <UncontrolledTooltip placement="top" target="emojipicker">
              {t("Inset emoji")}
            </UncontrolledTooltip>
          )}
        </li>

        <li className="list-inline-item" id="attachfile">
          <label className="m-0" htmlFor="file-input">
            <Icon
              stroke="gray"
              strokeWidth="1.215"
              fillcolor="gray"
              d="M14.5 8.216l-5.966 5.907c-1.729 1.703-4.509 1.703-6.237 0h0c-1.73-1.702-1.73-4.438 0-6.14L7.55 2.776c1.186-1.168 3.118-1.168 4.305 0h0c1.186 1.168 1.186 3.07 0 4.239l-4.78 4.739c-.678.667-1.729.667-2.407 0h0c-.677-.668-.677-1.702 0-2.37L8.737 5.38"
            />
          </label>
          <input
            ref={fileInputRef}
            className="d-none"
            disabled={isRecordingAudio}
            type="file"
            id="file-input"
            onChange={(e) => {
              handleSendFile(e?.target?.files[0]);
            }}
          />

          <UncontrolledTooltip placement="top" target="attachfile">
            {t("Attach file")}
          </UncontrolledTooltip>
        </li>
        <li className="list-inline-item" id="attachflashmessage">
          <label className="m-0" htmlFor="flash-message-input">
            <i
              className="mdi mdi-slash-forward-box font-size-20 align-middle"
              style={{
                color: "gray",
                cursor:
                  isRecordingAudio || messageValue?.length > 0
                    ? "not-allowed"
                    : "pointer",
              }}
              id="shortcuts"
            />
          </label>
          <input
            id="flash-message-input"
            className="d-none"
            disabled={isRecordingAudio || messageValue?.length > 0}
            onClick={() => {
              setSearchTextFlash((prev) => (prev ? null : true));
            }}
          />
          <UncontrolledTooltip placement="top" target="shortcuts">
            {t("Flash message")}
          </UncontrolledTooltip>
        </li>
      </div>

      {/*****BODY (TEXTAREA,SENDBUTTONS)*****/}
      <div className="d-flex w-100 px-3 my-1">
        <div className="d-flex w-100 mr-2">
          <TextareaAutosize
            ref={msgRef}
            id="msg"
            name="msg"
            type="textarea"
            className="d-flex w-100 form-control autoGrowthInput sendMsgInput"
            placeholder={`${t("messagePlaceholder")}  (${placeholder})`}
            autoComplete="off"
            maxRows="6"
            minRows="1"
            maxLength={messageMaxLength}
            value={messageValue}
            disabled={isRecordingAudio}
            onChange={(e) => {
              findFlashMessage(e.target.value);
              setMessageValue(e.target.value);
            }}
            onKeyDown={(e) => {
              switch (e.key) {
                case "Enter":
                  handleEnter(e);
                  break;
                case "ArrowUp":
                  handleArrowUp(e);
                  break;
                case "ArrowDown":
                  handleArrowDown(e);
                  break;
                case "Escape":
                  handleEscape(e);
                  break;
                default:
                  break;
              }
            }}
          />
        </div>
        <div className="d-flex align-items-start justify-content-end">
          {messageValue.length === 0 && isAudioFeature && !fileObj ? (
            <div className="h-100">
              <AnimateWidth
                className="h-100 align-items-start justify-content-end"
                side="right"
                duration="500"
                trigger={isOpenRecord}
                onEndAnimation={(e) => {
                  if (e === "out") {
                    setIsOpenButton(true);
                  }
                }}
              >
                <AudioRecord
                  isOpen={isOpenRecord}
                  onCancel={() => {
                    setIsRecordingAudio(false);
                    setIsOpenRecord(false);
                  }}
                  onSubmit={(e) => {
                    onSubmitAudio(e);
                    setIsRecordingAudio(false);
                    setIsOpenRecord(false);
                  }}
                />
              </AnimateWidth>
              <AnimateWidth
                className="h-100 align-items-start justify-content-end"
                side="right"
                duration="500"
                initialIsOpen={true}
                trigger={isOpenButton}
                onEndAnimation={(e) => {
                  if (e === "out") {
                    setIsOpenRecord(true);
                  }
                }}
              >
                <AudioButton
                  onClick={() => {
                    setIsRecordingAudio(true);
                    setIsOpenButton(false);
                  }}
                />
              </AnimateWidth>
            </div>
          ) : (
            <SendButton
              onClick={() => {
                handleSubmit();
              }}
              activeSubmit={isValidSubmit}
            />
          )}
        </div>
      </div>

      {/*****FOOTER (COUNTER)*****/}
      <Badge
        className="my-2"
        color={`${
          messageValue?.length < messageMaxLength ? "primary" : "danger"
        }  ml-3 mb-1`}
      >
        {messageMaxLength - (messageValue?.length ?? 0)}
      </Badge>
    </div>
  );
};

export default withTranslation()(RichInputs);
